import { IFormatter } from '../FormatterTypes';
import { TEDDisplayDate } from '../Displayers/TEDDisplayDate';
import { TEDValidateDate } from '../Validators/TEDValidateDate';
import { TEDParseDate } from '../Parsers/TEDParseDate';

class TEDFormatDate implements IFormatter {
  displayer = TEDDisplayDate.getInstance();
  parser = TEDParseDate.getInstance();
  validator = TEDValidateDate.getInstance();
}

export { TEDFormatDate };
